import { type Page } from './constants';
import createErrors from '../createErrors';

export type Component = 'AppointmentsPage' | 'UpcomingAppointmentsItem';

/**
 * Errors related to the About You page
 */
export const Errors = createErrors<Page, Component>('ServicesGrooming')({
    AppointmentsPage: {
        FetchAppointmentsFailed: {
            severity: 'HIGH',
            message: 'Failed to fetch appointments',
        },
        FetchPackagesFailed: {
            severity: 'HIGH',
            message: 'Failed to fetch packages',
        },
        FetchPetsFailed: {
            severity: 'HIGH',
            message: 'Failed to fetch pets',
        },
        GetEligibilityFailed: {
            severity: 'HIGH',
            message: 'Failed to get eligibility',
        },
        GetCustomerEligibilityFailed: {
            severity: 'HIGH',
            message: 'Failed to get customer eligibility',
        },
        GetCustomerPetEligibilityFailed: {
            severity: 'HIGH',
            message: 'Failed to get customer pet eligibility',
        },
    },
    UpcomingAppointmentsItem: {
        Confirm: {
            severity: 'HIGH',
            message: 'Failed to confirm appointment',
        },
        Cancel: {
            severity: 'HIGH',
            message: 'Failed to cancel appointment',
        },
    },
});
